import { render, staticRenderFns } from "./viewChatHistory.vue?vue&type=template&id=b84fe4fc&scoped=true&"
import script from "./viewChatHistory.vue?vue&type=script&lang=js&"
export * from "./viewChatHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84fe4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b84fe4fc')) {
      api.createRecord('b84fe4fc', component.options)
    } else {
      api.reload('b84fe4fc', component.options)
    }
    module.hot.accept("./viewChatHistory.vue?vue&type=template&id=b84fe4fc&scoped=true&", function () {
      api.rerender('b84fe4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/sop/viewChatHistory.vue"
export default component.exports